import './../../external/@lit/reactive-element/reactive-element.js';
import './../../external/lit-html/lit-html.js';
import './../../external/lit-element/lit-element.js';
import { css as i } from './../../external/@lit/reactive-element/css-tag.js';
var HeaderCss = i`

  header {
    display: flex;
    padding: var(--isceco-space-200);
    font-family: var(--isceco-font);
    overflow: visible;
    justify-content: space-between;
    border-bottom: 4px solid var(--isceco-color-red-500);
    padding-inline: 90px;
    padding-top: 19px;
    padding-bottom: 19px;
    background-color: white;
  }

  .left-header {
    display: flex;
    margin-top: 8px;
    flex: 1;
  }

  img {
    cursor: pointer;
    padding-right: var(--isceco-space-200);
    border-right: 1px solid var(--isceco-color-grey-300);
  }

  .text {
    padding-left: var(--isceco-space-200);
    background-color: var(--isceco-color-white-500);
    height: 100%;
    flex: 1;
    line-height: 1.5rem;
    font-weight: bold;
    /* align text to top, otherwise due to the line-height there would be a gap */
    position: relative;
    margin-top: -0.25rem;
  }

  slot {
    background-color: var(--isceco-color-white-500);
    display: flex;
  }

  @media (max-width: 991.98px) {
    header {
      padding-inline: 20px;
      padding-top: 19px;
      padding-bottom: 19px;
      background-color: white;
    }

    .text {
      font-size: 0.75rem;
    }

    .image {
      display: grid;
      grid-template-columns: 40px 2fr 8fr;
      overflow: hidden;
    }
  }
`;
export { HeaderCss as default };
